import { CopyInput } from '@/components/atoms/CopyInput/CopyInput';
import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';

export type ContextVariableInputProps = { label: string; value: string };

export const ContextVariableInput = ({ label, value }: ContextVariableInputProps) => {
  return (
    <>
      <InfoTooltip content={label} side="left" sideOffset={-4}>
        <span className="mb-1.5 block truncate text-sm leading-5 font-medium text-muted-foreground">
          {label}
        </span>
      </InfoTooltip>

      <CopyInput value={value} tooltipSide="left" />
    </>
  );
};
